import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'
import Autocomplete from '../Autocomplete'
import clsx from 'clsx'

/**
 * props => options
 * hideAllPlatform => true/false 是否隱藏全部站台選項
 */

class PfSubPfSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'PfSubPfSelect', options)
        }
    }

    state = {
        pfId: '',
        pfSubPfId: 'all',
        pfList: [],
        subPfList: {},
        subPfSortList: [],
    }

    pfSubPfMap = {}

    componentDidMount() {
        this.pfSubPfMap = utils.deepCopy(this.props.dataService.pfSubPfMap)

        if (this.props.options && this.props.options.extraPfSubPfList) {
            Object.entries(this.props.options.extraPfSubPfList).forEach(([pfSubPfId, elem]) => {
                this.pfSubPfMap[pfSubPfId] = elem
            })
        }

        const pfList = [] // 整理幣別(站台)類別
        Object.entries(this.pfSubPfMap).forEach(([pfSubPfId, elem]) => {
            if (!this.props.auth.isSuperUser && pfSubPfId === 'ze_ze') return
            if (!pfList.includes(elem.pf_id)) pfList.push(elem.pf_id)
        })

        const sortPfList = utils.sortPlatform(pfList) // 幣別(站台)排序

        const pfId = this.state.pfId ? this.state.pfId : this.props?.options?.hideAllPlatform ? sortPfList[0] : 'all' // 預設幣別(站台)
        this.setState(
            {
                pfId: pfId,
                pfList: sortPfList,
            },
            () => this.setSubPfList(true)
        )

        this.props.onRef(this)
    }

    setSubPfList(needCheckPfSubPfId) {
        const subPfList = {}
        let subPfSortList = []
        this.state.pfList.forEach(pfId => {
            const PfGroup = {}
            Object.entries(this.pfSubPfMap).forEach(([pfSubPfId, elem]) => {
                /** 已關閉平台不顯示 */
                if (!elem.is_display) { return }
                // if (!elem.is_active) { return }
                /** 指定可顯示平台列表 */
                if (this.props.options?.openSubPfList && this.props.options?.openSubPfList.length !== 0) {
                    if (this.props.options.openSubPfList.includes(elem.pf_sub_pf_id) && !PfGroup[pfSubPfId] && (elem.pf_id === this.state.pfId && this.state.pfId === pfId)) {
                        PfGroup[pfSubPfId] = elem
                    }
                } else if ((elem.pf_id === pfId && this.state.pfId === 'all') || (elem.pf_id === this.state.pfId && this.state.pfId === pfId)) {
                    PfGroup[pfSubPfId] = elem
                }
            })
            const sortGroup = utils.convertSort({ source: PfGroup })
            subPfSortList = [...subPfSortList, ...sortGroup]
        })
        
        const pfSubPfId =
            needCheckPfSubPfId && this.state.pfSubPfId !== 'all'
                ? this.state.pfSubPfId
                : this.props.options && this.props.options.hideAllSubPlatform
                ? subPfSortList[0].pf_sub_pf_id
                : 'all'

        this.setState(
            {
                pfSubPfId,
                subPfList,
                subPfSortList,
            },
            () => {
                this.props.options && typeof this.props.options.subPfChangeCallback === 'function' && this.props.options.subPfChangeCallback()
            }
        )
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    getOptionList = () => {
        const optionList = this.state.subPfSortList.map((item) => ({
            key: item.pf_sub_pf_id,
            label: item.name,
            value: item.pf_sub_pf_id,
        }))
        return optionList
    }

    render() {
        const optionList = this.getOptionList()
        const hideSubPlatform = this.props?.options?.hideAllSubPlatform ?? false
        const hideAllPlatform = this.props?.options?.hideAllPlatform ?? false
        const showAutocomplete = optionList.length && !this.props.options.hideAutocomplete
        const allOption = !hideSubPlatform

        return (
            <React.Fragment>
                <FormControl
                    className={clsx(
                        this.props.classes.formControl,
                        {
                            [this.props.classes.hide] : this.props.options && (this.props.options.hide || this.props.options.hidePlatform)
                        }
                    )}
                >
                    <InputLabel htmlFor="age-simple">{this.t('platform')}</InputLabel>
                    <Select
                        disabled={this.props.options?.disabled}
                        value={this.state.pfId}
                        onChange={(event) => {
                            this.setState(
                                {
                                    pfId: event.target.value,
                                },
                                () => {
                                    this.setSubPfList()
                                    if (this.props.options?.pfChangeCallback) {
                                        this.props.options.pfChangeCallback()
                                    }
                                }
                            )
                        }}>
                        {!hideAllPlatform && <MenuItem value="all">
                            {this.t('allPlatform')}
                        </MenuItem>}
                        {this.state.pfList.map((key) => (
                            <MenuItem value={key} key={key}>
                                {this.t('Platform.' + key) +
                                    (this.props.options && this.props.options.hideCurrency
                                        ? ''
                                        : ` (${this.t('Currency.' + utils.getPfCurrency(key))})`)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className={this.props.options && this.props.options.hide ? this.props.classes.hide : ''}>
                    {showAutocomplete && (
                        <Autocomplete
                            value={this.state.pfSubPfId}
                            onChange={(option) => {
                                this.setState(
                                    {
                                        pfSubPfId: option.value,
                                    },
                                    () => {
                                        this.props.options &&
                                            typeof this.props.options.subPfChangeCallback === 'function' &&
                                            this.props.options.subPfChangeCallback()
                                    }
                                )
                            }}
                            allOption={allOption}
                            allLabel={this.t('allSubPlatform')}
                            options={optionList}
                            getOptionLabel={(option) => option.label}
                            renderOption={(option) => <>{option.label}</>}
                            label={this.t('subPlatform')}
                            inputClassName={this.props.options && this.props.options.hide ? this.props.classes.hide : this.props.classes.formControl}
                        />
                    )}
                </FormControl>
            </React.Fragment>
        )
    }
}

PfSubPfSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    options: PropTypes.object,
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(PfSubPfSelect)
